import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface OverlayDescriptor {
  id: string;
  kind: string;
  title: string;
  closable: boolean;
  layer?: number;
  closeReason?: string;
}

interface OverlayState {
  stack: OverlayDescriptor[];
  toasts: Array<{ id: string; message: string; tone: 'info' | 'success' | 'danger' }>;
}

const initialState: OverlayState = { stack: [], toasts: [] };

export const overlaySlice = createSlice({
  name: 'overlays',
  initialState,
  reducers: {
    openOverlay: (state, action: PayloadAction<OverlayDescriptor>) => {
      state.stack = state.stack.filter((item) => item.id !== action.payload.id);
      state.stack.push(action.payload);
      state.stack.sort((left, right) => (left.layer ?? 0) - (right.layer ?? 0));
    },
    closeOverlay: (state, action: PayloadAction<string>) => {
      state.stack = state.stack.filter((item) => item.id !== action.payload);
    },
    closeTopOverlay: (state) => {
      const top = state.stack.at(-1);
      if (top?.closable) state.stack.pop();
    },
    pushToast: (state, action: PayloadAction<OverlayState['toasts'][number]>) => {
      state.toasts.push(action.payload);
    },
    removeToast: (state, action: PayloadAction<string>) => {
      state.toasts = state.toasts.filter((item) => item.id !== action.payload);
    },
  },
});

export const overlayActions = overlaySlice.actions;
